export const SHARED_WEB_HOSTS = ['app.flink.coop', 'staging.flink.coop'];
